import ContentLoader from 'components/content/ContentLoader';
import MainPage from 'pages/MainPage';
import { useGetUserAttributesQuery } from 'services/user';

const MainPageWrapper = () => {
    const { data: userAttributes, isLoading } = useGetUserAttributesQuery('User');
    const userKey = userAttributes?.sub;
    if (isLoading || !userKey) {
        return <ContentLoader height={107} width={728} data-testid='main-page-content-loader' />;
    }
    return <MainPage key={userKey} userId={userKey} />;
};

export default MainPageWrapper;
